/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Preference_LabelInputs */

const en_us2_exercise_personal_preference_label = /** @type {(inputs: Exercise_Personal_Preference_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your preference`)
};

const pt_br2_exercise_personal_preference_label = /** @type {(inputs: Exercise_Personal_Preference_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua preferência`)
};

const es_419_exercise_personal_preference_label = /** @type {(inputs: Exercise_Personal_Preference_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu preferencia`)
};

const pt_pt2_exercise_personal_preference_label = /** @type {(inputs: Exercise_Personal_Preference_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua preferência`)
};

const fr_fr2_exercise_personal_preference_label = /** @type {(inputs: Exercise_Personal_Preference_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta préférence`)
};

const de_de2_exercise_personal_preference_label = /** @type {(inputs: Exercise_Personal_Preference_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Vorliebe`)
};

const it_it2_exercise_personal_preference_label = /** @type {(inputs: Exercise_Personal_Preference_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua preferenza`)
};

/**
* | output |
* | --- |
* | "Your preference" |
*
* @param {Exercise_Personal_Preference_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_preference_label = /** @type {((inputs?: Exercise_Personal_Preference_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Preference_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_preference_label(inputs)
	if (locale === "es-419") return es_419_exercise_personal_preference_label(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_preference_label(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_preference_label(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_preference_label(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_preference_label(inputs)
	return en_us2_exercise_personal_preference_label(inputs)
});
export { exercise_personal_preference_label as "exercise-personal.preference_label" }